import { Link } from "@/router/Router";
import { Container } from "@/components/ui/Primitives";
import { PhotoSlot } from "@/components/ui/PhotoSlot";
import { Reveal } from "@/components/motion/Reveal";
import { Icon } from "@/components/ui/Icon";

const PATHS = [
  {
    word: "Belong",
    title: "Find a care group",
    text: "Church is better close to home. Care groups meet across the city during the week.",
    href: "/care-groups",
    photo: "/media/home/pathway-belong.jpg",
    tone: "leaf" as const,
  },
  {
    word: "Grow",
    title: "Believers Academy",
    text: "Membership, Maturity, Ministry and Missions — Saturdays, 7–9 AM.",
    href: "/connect/believers-academy",
    photo: "/media/home/pathway-grow.jpg",
    tone: "evergreen" as const,
  },
  {
    word: "Serve",
    title: "Join a team",
    text: "Every member is a minister. Discover where your S.H.A.P.E fits.",
    href: "/connect/join-a-team",
    photo: "/media/home/pathway-serve.jpg",
    tone: "flame" as const,
  },
];

/** Belong · Grow · Serve — the three steps into the life of the church. */
export function Pathways() {
  return (
    <section className="pathways" aria-labelledby="pathways-title">
      <Container>
        <div className="pathways__head">
          <Reveal>
            <span className="rule" aria-hidden />
          </Reveal>
          <Reveal delay={60}>
            <h2 id="pathways-title" className="pathways__title">
              Belong, grow and <em>serve with us.</em>
            </h2>
          </Reveal>
          <Reveal delay={120}>
            <p className="pathways__lead">Church isn't only a service you attend — it's a family you belong to. Here's where to start.</p>
          </Reveal>
        </div>
        <ol className="pathways__list">
          {PATHS.map((p, i) => (
            <Reveal as="li" key={p.word} delay={i * 110} className="pathways__item">
              <Link to={p.href} className="pathway">
                <PhotoSlot src={p.photo} alt="" label={p.word} tone={p.tone} className="pathway__photo" />
                <span className="pathway__shade" aria-hidden />
                <span className="pathway__body">
                  <span className="pathway__num">0{i + 1}</span>
                  <span className="pathway__word">{p.word}</span>
                  <span className="pathway__title">
                    {p.title} <Icon name="arrowRight" size={18} />
                  </span>
                  <span className="pathway__text">{p.text}</span>
                </span>
              </Link>
            </Reveal>
          ))}
        </ol>
      </Container>
    </section>
  );
}
